import script from "./EditEntityDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EditEntityDialog.vue?vue&type=script&setup=true&lang=js"

import "./EditEntityDialog.vue?vue&type=style&index=0&id=eff8c916&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eff8c916"]])

export default __exports__